import { Link } from "react-router-dom";
import { games } from "@/mocks/games";

export default function Masterpieces() {
  const master = games.filter((g) => g.isMasterpiece);

  return (
    <section id="masterpieces" className="mx-auto w-full max-w-7xl px-4 py-16 md:px-6 md:py-20">
      <div className="flex flex-col gap-2 md:flex-row md:items-end md:justify-between">
        <div>
          <p className="text-xs font-medium uppercase tracking-[0.2em] text-accent-600">Masterpieces</p>
          <h2 className="mt-2 font-display text-2xl font-bold text-foreground-950 md:text-3xl">
            神作盘点 · 十年难遇的标杆
          </h2>
        </div>
        <Link to="/ranking" className="inline-flex items-center gap-1 text-sm font-medium text-accent-700 hover:text-accent-600">
          完整榜单 <i className="ri-arrow-right-line"></i>
        </Link>
      </div>

      <div className="mt-8 grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
        {master.map((g) => (
          <Link
            key={g.id}
            to={`/review/${g.id}`}
            className="group overflow-hidden rounded-2xl border border-background-200/70 bg-background-100"
          >
            <div className="relative aspect-[16/10] overflow-hidden">
              <img
                src={g.cover}
                alt={`${g.title} 神作封面`}
                className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
              />
              <div className="absolute left-3 top-3 flex gap-2">
                <span className="rounded-full bg-accent-500 px-3 py-1 text-xs font-medium text-background-50">神作</span>
                <span className="rounded-full bg-background-50/90 px-3 py-1 text-xs font-medium text-foreground-700 backdrop-blur-sm">{g.year}</span>
              </div>
              <div className="absolute right-3 top-3 rounded-full bg-black/45 px-3 py-1 text-sm font-bold text-primary-300 backdrop-blur-sm">
                {g.score.toFixed(1)} 分
              </div>
            </div>
            <div className="p-5">
              <div className="flex items-center gap-2">
                <h3 className="font-display text-lg font-bold text-foreground-950 group-hover:text-accent-700">{g.title}</h3>
                <span className="text-xs text-foreground-400">{g.sub}</span>
              </div>
              <p className="mt-2 line-clamp-2 text-sm leading-relaxed text-foreground-600">{g.blurb}</p>
              <div className="mt-4 flex flex-wrap gap-2">
                {g.tags.slice(0, 3).map((t) => (
                  <span key={t} className="rounded-full bg-secondary-100 px-2.5 py-0.5 text-xs text-secondary-700">{t}</span>
                ))}
              </div>
            </div>
          </Link>
        ))}
      </div>
    </section>
  );
}